module.exports = __webpack_public_path__ + "bandeira_azul.svg?5c7d47f57e291176f21e02d9a725d989";


//////////////////
// WEBPACK FOOTER
// ./client/assets/icones_app/bandeira_azul.svg
// module id = 1136
// module chunks = 0